module.exports = __webpack_public_path__ + "assets/certificate_pdf/ssa_111_1.2d6feada.pdf";